import React, { useEffect, useState } from "react";
import {
  logo,
  footerIcon1,
  footerIcon2,
  footerIcon3,
} from "../../assets/images";
import { useTranslation } from "react-i18next";
import axios from "axios";

const Footer = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language; // Aktif dili alıyoruz

  const [settings, setSettings] = useState([]);

  useEffect(() => {
    getSettings();
  }, []);

  async function getSettings() {
    try {
      // API'den verileri çekiyoruz
      const response = await axios.get(
        "https://www.caspianrocksolutions.com/caspianrocksolutions/settings.php"
      );
      setSettings(response.data.data[0]); // Gelen veriyi state'e kaydediyoruz
      console.log(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error); // Hata durumunda mesaj yazdırıyoruz
    }
  }

  return (
    <div>
      <footer className="bg-[white] text-white">
        <div className="max-w-containerSm md:max-w-container mx-auto pt-10">
          <div className="md:flex justify-between pb-8 border-b-[1px] border-[#979797]">
            <div className="md:w-[180px]">
              <img alt="Logo" className="w-[120px]" src={logo}></img>
              {/* <p className='text-[17px] mt-[20px] md:mt-[40px] font-thirdFont'>{t("Lazer, stomotoloji və kosmetoloji məhsulların satışı və servisi")}</p> */}
              <ul className="space-y-2 md:space-y-2 text-[#7D7D7D] mt-5">
                <div className="flex gap-2 items-center">
                  <img
                    alt="Location"
                    className="w-6 h-6"
                    src={footerIcon1}
                  ></img>
                  <p className="text-[#7D7D7D]">{settings.location}</p>
                </div>
              </ul>
            </div>
            <div className="md:w-[143px] mt-10 md:mt-0 text-[#DCDCDC]">
              <h4 className="font-medium text-[18px] text-[#222222]">
                {t("Quick Links")}
              </h4>
              <ul className="space-y-2 md:space-y-2 mt-5 text-[#7D7D7D]">
                <li>
                  <a href={`/${currentLanguage}`} className="hover:underline">
                    <i className={`fas fa-chevron-right mr-3`} />
                    {t("Home")}
                  </a>
                </li>
                <li>
                  <a
                    href={`/${currentLanguage}/about`}
                    className="hover:underline"
                  >
                    <i className={`fas fa-chevron-right mr-3`} />
                    {t("About")}
                  </a>
                </li>
                <li>
                  <a
                    href={`/${currentLanguage}/services`}
                    className="hover:underline"
                  >
                    <i className={`fas fa-chevron-right mr-3`} />
                    {t("Services")}
                  </a>
                </li>
                <li>
                  <a
                    href={`/${currentLanguage}/qhse`}
                    className="hover:underline"
                  >
                    <i className={`fas fa-chevron-right mr-3`} />
                    {t("QHSE")}
                  </a>
                </li>
                <li>
                  <a
                    href={`/${currentLanguage}/contact`}
                    className="hover:underline"
                  >
                    <i className={`fas fa-chevron-right mr-3`} />
                    {t("Contact")}
                  </a>
                </li>
              </ul>
            </div>
            <div className="md:w-[398px] mt-10 md:mt-0 text-[#DCDCDC]">
              <h4 className="font-medium text-[18px] text-[#222222]">
                {t("Əlaqə")}
              </h4>
              <ul className="space-y-2 md:space-y-2 text-[#7D7D7D] mt-5">
                <div className="flex gap-2 items-center">
                  <img
                    alt="Location"
                    className="w-6 h-6"
                    src={footerIcon1}
                  ></img>
                  <p className="text-[#7D7D7D]">{settings.location}</p>
                </div>
                <div className="flex gap-2 items-center">
                  <img alt="Email" className="w-6 h-6" src={footerIcon2}></img>
                  <p className="text-[#7D7D7D]">{settings.email}</p>
                </div>
                <div className="flex gap-2">
                  <img alt="Phone" className="w-6 h-6" src={footerIcon3}></img>
                  <p className="text-[#7D7D7D]">{settings.phone1}</p>
                </div>
              </ul>
            </div>
          </div>
        </div>
        {/* <div className="max-w-containerSm md:max-w-container md:flex justify-between mx-auto py-4 text-sm text-[#222222]">
        <p className="mb-2 md:mb-0">CaspianRockSolutions.com © {t("Bütün hüquqlar qorunur.")}</p>
        <a href='https://www.prosayt.az/'><p>{t("Sayt hazırlandı")}: Prosayt.az</p></a>
      </div> */}
      </footer>
    </div>
  );
};

export default Footer;
